import {Command} from 'commands/Commands';

export class SetOrder extends Command {
    type: string = 'Member.SetOrder';
    priority = 150;    
}

